const apiMap = {
  login: {
    url: "/auth/login",
    method: "post",
  },
  refreshToken: {
    url: "/auth/refreshToken",
    method: "post",
  },
  shopperLogin: {
    url: "/auth/shopperLogin",
    method: "post",
  },
  shopperTokenVerify: {
    url: "/auth/shopperTokenVerify",
    method: "post",
  },
  // forgotPassword: {
  //     url: '/oauth/forgotPassword',
  //     method: 'post'
  // },
  getCurrent: {
    url: "/auth/getCurrent",
    method: "post",
  },
  getCurrentShopper: {
    url: "/auth/getCurrentShopper",
    method: "post",
  },
  addUser: {
    url: "/api/user/add",
    method: "post",
  },
  getUsers: {
    url: "/api/user/get",
    method: "post",
  },
  addShopper: {
    url: "/api/shopper/add",
    method: "post",
  },
  editShopper: {
    url: "/api/shopper/edit",
    method: "post",
  },
  getShoppers: {
    url: "/api/shopper/get",
    method: "post",
  },
  getOnlineShoppers: {
    url: "/api/shopper/online",
    method: "post",
  },
  removeAllShoppersFromSite: {
    url: "/api/shopper/emptySite",
    method: "post",
  },
  deleteShopper: {
    url: "/api/shopper/delete",
    method: "post",
  },
  getSensors: {
    url: "/api/sensor/get",
    method: "post",
  },
  getSiteSensors: {
    url: "/api/sensor/getSiteSensors",
    method: "post",
  },
  downloadSensorsQRCodesPDF: {
    url: "/api/sensor/downloadQRCodesPDF",
    method: "post",
  },
  editSensor: {
    url: "/api/sensor/edit",
    method: "post",
  },
  getSensorStatuses: {
    url: "/api/sensor/statuses",
    method: "post",
  },
  calibrateShelf: {
    url: "/api/sensor/calibrate",
    method: "post",
  },
  calibratePoseFloor: {
    url: "/api/camera/calibratePoseFloor",
    method: "post",
  },
  getDistributors: {
    url: "/api/distributor/get",
    method: "post",
  },
  addDistributor: {
    url: "/api/distributor/add",
    method: "post",
  },
  editDistributor: {
    url: "/api/distributor/edit",
    method: "post",
  },
  distributorAddShelf: {
    url: "/api/distributor/distributorAddShelf",
    method: "post",
  },
  distributorAddStep: {
    url: "/api/distributor/distributorAddStep",
    method: "post",
  },
  distributorAddShelfToInstaller: {
    url: "/api/distributor/distributorAddShelfToInstaller",
    method: "post",
  },
  distributorAddStepToInstaller: {
    url: "/api/distributor/distributorAddStepToInstaller",
    method: "post",
  },
  getInstallers: {
    url: "/api/installer/get",
    method: "post",
  },
  addInstaller: {
    url: "/api/installer/add",
    method: "post",
  },
  // editDistributor: {
  //     url: '/api/distributor/edit',
  //     method: 'post'
  // },
  // distributorAddShelf: {
  //     url: '/api/distributor/distributorAddShelf',
  //     method: 'post'
  // },
  // distributorAddStep: {
  //     url: '/api/distributor/distributorAddStep',
  //     method: 'post'
  // }
  getCategories: {
    url: "/api/category/get",
    method: "post",
  },
  getCategoriesWithActiveProductsOnly: {
    url: "/api/category/getCategoriesWithActiveProductsOnly",
    method: "post",
  },
  getCategoriesWithProductCount: {
    url: "/api/category/getCategoriesWithProductCount",
    method: "post",
  },
  reorderCategories: {
    url: "/api/category/reorder",
    method: "post",
  },
  getProducts: {
    url: "/api/product/get",
    method: "post",
  },
  getInventoryProducts: {
    url: "/api/product/getInventoryProducts",
    method: "post",
  },
  editProduct: {
    url: "/api/product/edit",
    method: "post",
  },
  addProduct: {
    url: "/api/product/add",
    method: "post",
  },
  addProductsChunk: {
    url: "/api/product/addManyProducts",
    method: "post",
  },
  removeProduct: {
    url: "/api/product/remove",
    method: "post",
  },
  getShopperCart: {
    url: "/api/shopperCart/get",
    method: "post",
  },
  resetShopperCart: {
    url: "/api/shopperCart/delete",
    method: "post",
  },
  addCategory: {
    url: "/api/category/add",
    method: "post",
  },
  editCategory: {
    url: "/api/category/edit",
    method: "post",
  },
  removeCategory: {
    url: "/api/category/remove",
    method: "post",
  },
  getEdges: {
    url: "/api/edge/get",
    method: "post",
  },
  getEdgesOnly: {
    url: "/api/edge/getEdges",
    method: "post",
  },
  distributorCreateEdge: {
    url: "/api/edge/distributorCreateEdge",
    method: "post",
  },
  distributorAddEdgeToInstaller: {
    url: "/api/edge/distributorAddEdgeToInstaller",
    method: "post",
  },
  addClient: {
    url: "/api/client/add",
    method: "post",
  },
  editClient: {
    url: "/api/client/edit",
    method: "post",
  },
  getClients: {
    url: "/api/client/get",
    method: "post",
  },
  siteCheckin: {
    url: "/api/site/checkin",
    method: "post",
  },
  siteCheckout: {
    url: "/api/site/checkout",
    method: "post",
  },
  getSites: {
    url: "/api/site/get",
    method: "post",
  },
  getStores: {
    url: "/api/site/get",
    method: "post",
  },

  getSiteTypes: {
    url: "/api/site/getTypes",
    method: "get",
  },
  setSiteType: {
    url: "/api/site/setType",
    method: "post",
  },
  addSite: {
    url: "/api/site/add",
    method: "post",
  },
  editSite: {
    url: "/api/site/edit",
    method: "post",
  },
  setSitePlayMode: {
    url: "/api/site/setSitePlayMode",
    method: "post",
  },
  setSiteDebugMode: {
    url: "/api/site/setSiteDebugMode",
    method: "post",
  },
  setSiteIsRecording: {
    url: "/api/site/setSiteIsRecording",
    method: "post",
  },
  installerAddEdgeToClient: {
    url: "/api/edge/installerAddEdgeToClient",
    method: "post",
  },
  getEdgeResponse: {
    url: "/api/edge/getEdgeResponse",
    method: "post",
  },
  intallerEditClientEdge: {
    url: "/api/edge/intallerEditClientEdge",
    method: "post",
  },
  installerAddSensorsToEdge: {
    url: "/api/sensor/installerAddSensorsToEdge",
    method: "post",
  },
  removeSensorFromEdge: {
    url: "/api/sensor/removeSensorFromEdge",
    method: "post",
  },
  getCameras: {
    url: "/api/camera/get",
    method: "post",
  },
  getSiteCameras: {
    url: "/api/camera/getForSite",
    method: "post",
  },
  getCamerasByIds: {
    url: "/api/camera/getByIds",
    method: "post",
  },
  addCamera: {
    url: "/api/camera/add",
    method: "post",
  },
  editCamera: {
    url: "/api/camera/edit",
    method: "post",
  },
  deleteCamera: {
    url: "/api/camera/remove",
    method: "post",
  },
  getFields: {
    url: "/api/field/get",
    method: "post",
  },
  getFieldswithPlacements: {
    url: "/api/field/get-with-placements",
    method: "post",
  },
  getSiteFields: {
    url: "/api/field/getSiteFields",
    method: "post",
  },
  addField: {
    url: "/api/field/add",
    method: "post",
  },
  editField: {
    url: "/api/field/edit",
    method: "post",
  },
  removeField: {
    url: "/api/field/remove",
    method: "post",
  },
  edgeSaveFloor: {
    url: "/api/edge/edgeSaveFloor",
    method: "post",
  },
  testSensor: {
    url: "/api/site/testSensor",
    method: "post",
  },
  getAlerts: {
    url: "/api/alert/get",
    method: "post",
  },
  editAlert: {
    url: "/api/alert/edit",
    method: "post",
  },
  resetAlerts: {
    url: "/api/alert/reset",
    method: "post",
  },
  getPastAlerts: {
    url: "/api/alert/history",
    method: "get",
  },
  getSensorModels: {
    url: "/api/firmware/firmwareSensorModel",
    method: "post",
  },
  createSensorModel: {
    url: "/api/firmware/firmwareSensorModelCreate",
    method: "post",
  },
  deleteSensorModel: {
    url: "/api/firmware/firmwareSensorModelDelete",
    method: "post",
  },
  uploadFirmware: {
    url: "/api/firmware/add",
    method: "post",
  },
  getFirmware: {
    url: "/api/firmware/get",
    method: "post",
  },
  deleteFirmware: {
    url: "/api/firmware/delete",
    method: "post",
  },
  editFirmware: {
    url: "/api/firmware/edit",
    method: "post",
  },
  restartEdge: {
    url: "/api/edge/restart",
    method: "post",
  },
  restartSite: {
    url: "/api/site/restart",
    method: "post",
  },
  setAlarmsSite: {
    url: "/api/site/setAlarms",
    method: "post",
  },
  setAlarmsField: {
    url: "/api/field/setAlarms",
    method: "post",
  },
  setAlarmsSensor: {
    url: "/api/field/setAlarms",
    method: "post",
  },
  setProductInventory: {
    url: "/api/inventory/setInventory",
    method: "post",
  },
  getSigmaBusketInventory: {
    url: "/api/inventory/sigmaBusket/get",
    method: "post",
  },
  setSigmaBusketInventory: {
    url: "/api/inventory/sigmaBusket/edit",
    method: "post",
  },
  getAlertsByTypeAndCount: {
    url: "/api/alert/alertsByTypeAndCount",
    method: "post",
  },
  getAlertsByParams: {
    url: "/api/alert/getByParams",
    method: "post",
  },
  getFieldsLean: {
    url: "/api/field/getLean",
    method: "post",
  },
  getPlacements: {
    url: "/api/placement/get",
    method: "post",
  },
  debugCapture: {
    url: "/api/debug/capture",
    method: "post",
  },
  downloadDebugCapture: {
    url: "/api/debug/download-folder",
    method: "post",
  },
  uploadPlanogram: {
    url: "/api/field/upload-planogram",
    method: "post",
  },
  removePlacementsBySensorId: {
    url: "/api/placement/removePlacementsBySensorId",
    method: "post",
  },
  removeAlertsBySensorId: {
    url: "/api/alert/removeAlertsBySensorId",
    method: "post",
  },
  getTempCarts: {
    url: "/api/cart/get",
    method: "post",
  },
  getActiveCarts: {
    url: "/api/cart/active-carts",
    method: "post",
  },
  checkPlanogramBySensorId: {
    url: "/api/field/check-planogram",
    method: "post",
  },
  ReloadPlanogramsFromDB: {
    url: "/api/field/reload-planograms-from-db",
    method: "post",
  },
  applyPlanogram: {
    url: "/api/field/apply-planogram",
    method: "post",
  }

};

export default apiMap;
